import us from '../../defines';
import ThumbnailControl from './thumbnail-control';
import {ThumbnailHeatMapOverlay} from './ThumbnailHeatmapOverlay';
import app from '../../public-api';
import {env} from '../../lib/utility/browser-compatibility';

app.plugins.register({
  name: 'us:thumbnail',
  extends: 'viewport',
  dependencies: ['us:settings:visibility-panel', 'us:user-config'],
  canStart () {
    return env.supportsCanvas && us.ENABLETHUMB;
  },
  constructor: ThumbnailControl
});

app.plugins.register({
  name: 'us:heatmap',
  extends: 'viewport',
  dependencies: ['us:user-config', 'us:thumbnail'],
  canStart () {
    // us.ENABLEHEATMAP is set true/false via VILSettings.
    //    If it is false at that time, the switch    to enable/disable it IS NOT displayed in settings/visibility
    //        and the drawing functions return without drawing.
    //    If it is true at that time, the switch to enable/disable it IS displayed in settings/visibility
    //        and the drawing functions obey the visibility setting.
    //
    //    This object uses HTML5 canvas.  IF the browser is not canvas-able, it disables itself.
    //    canvas references:
    //        http://www.w3schools.com/tags/ref_canvas.asp
    //
    return env.supportsCanvas && us.ENABLEHEATMAP;
  },
  constructor: ThumbnailHeatMapOverlay
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/thumbnail/thumbnail-loader.js